/**
 * Build the JSON body Socket.IO emits for `join` and `request` events.
 *
 * Platform-CMS-Backend `Messenger.ts` expects plain objects (no AES wrapper):
 * - `join`: jwt.verify(data.token), data.user_id
 * - `request`: data.event, data.data (after join populated socket.userObj)
 *
 * Same shapes as React Native `SocketFuntions.ts`. Transport remains WSS/TLS.
 */
export function buildSocketOutboundPayload(event, data) {
  switch (event) {
    case 'join': {
      return data;
    }
    default: {
      return { data, event };
    }
  }
}
